export default __webpack_public_path__ + "static/media/filter_icon_reception_blue.cc6131f7.svg";